<template>
	<div class="page">
		<div class="main">
			<el-tabs style="width: 100%;" v-model="activeName">
				<el-tab-pane label="签证订单" name="first" :key="'first'">
					<vsaorder :orderStatus="orderStatus" :payStatus="payStatus"></vsaorder>					
				</el-tab-pane>

				<el-tab-pane label="保险订单" name="second" :key="'second'">
					<InsuranceOrder></InsuranceOrder>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
	import vsaorder from '@/components/orderlist/vsaorder.vue'
	import InsuranceOrder from '@/components/orderlist/InsuranceOrder.vue'
	export default {
		components: {
			vsaorder,
			InsuranceOrder,
		},
		data() {
			return {
				activeName: "first",
				orderStatus: '-2',
				payStatus:'-1'
			}
		},
		methods: {

		},
		created() {
			let {
				active = 0, orderStatus = '-2',payStatus='-1'
			} = this.$route.query
			if (active == 1) this.activeName = 'second'
			setTimeout(() => {
				this.orderStatus = orderStatus
				this.payStatus=payStatus
			},500)
		}
	}
</script>

<style lang='less' scoped>
	.main {
		text-align: left;
		/* width: 900px; */
		width: 75rem;
		/* width: 900px; */
		margin: 1.25rem auto;
		background-color: #fff;
		box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		padding: 1.25rem;
		box-sizing: border-box;
	}
</style>



// WEBPACK FOOTER //
// src/page/product/orderlist.vue